class ArtisticProduct extends HTMLElement {
  connectedCallback() {
    this.index = 0;
    this.slides = [...this.querySelectorAll('[data-artistic-slide]')];
    this.track = this.querySelector('[data-artistic-track]');
    this.current = this.querySelector('[data-artistic-current]');
    this.lightbox = this.querySelector('[data-artistic-lightbox]');
    this.querySelector('[data-artistic-prev]')?.addEventListener('click', () => this.show(this.index - 1));
    this.querySelector('[data-artistic-next]')?.addEventListener('click', () => this.show(this.index + 1));
    this.querySelector('[data-artistic-zoom]')?.addEventListener('click', () => this.openLightbox());
    this.querySelectorAll('[data-dialog-close]').forEach((button) => button.addEventListener('click', () => button.closest('dialog')?.close()));
    this.querySelectorAll('dialog').forEach((dialog) => dialog.addEventListener('click', (event) => {
      if (event.target === dialog) dialog.close();
    }));
    this.querySelectorAll('[data-artistic-video-play]').forEach((button) => button.addEventListener('click', () => this.playVideo(button)));
    this.bindSwipe();
    this.show(0);
  }

  show(index) {
    if (!this.slides.length) return;
    this.index = (index + this.slides.length) % this.slides.length;
    this.track.style.transform = `translateX(-${this.index * 100}%)`;
    if (this.current) this.current.textContent = this.index + 1;
  }

  openLightbox() {
    const image = this.slides[this.index]?.querySelector('img');
    const target = this.lightbox?.querySelector('img');
    if (!image || !target || !this.lightbox) return;
    target.src = image.currentSrc || image.src;
    target.alt = image.alt;
    this.lightbox.showModal();
  }

  playVideo(button) {
    const media = button.closest('[data-artistic-video-media]');
    const videoId = button.dataset.videoId;
    if (!media || !videoId) return;
    const iframe = document.createElement('iframe');
    iframe.src = `https://www.youtube-nocookie.com/embed/${encodeURIComponent(videoId)}?autoplay=1&rel=0`;
    iframe.title = button.dataset.videoTitle || 'YouTube video';
    iframe.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
    iframe.allowFullscreen = true;
    iframe.referrerPolicy = 'strict-origin-when-cross-origin';
    media.replaceChildren(iframe);
  }

  bindSwipe() {
    let start = 0;
    this.track?.addEventListener('touchstart', (event) => {
      start = event.touches[0].clientX;
    }, { passive: true });
    this.track?.addEventListener('touchend', (event) => {
      const delta = event.changedTouches[0].clientX - start;
      if (Math.abs(delta) > 45) this.show(this.index + (delta < 0 ? 1 : -1));
    }, { passive: true });
  }
}

if (!customElements.get('artistic-product')) customElements.define('artistic-product', ArtisticProduct);